<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="row d-flex justify-content-between">
            <div class="col-12 col-md-8">
              <filter-estatisticas @updateFiltrosEstatisticas="updateFiltrosEstatisticas" :estatisticaInfo="estatisticaInfo"></filter-estatisticas>
            </div>

            <div class="col-12 col-md-4">
              <button
                :disabled="!!loadingRelatorio"
                type="text"
                :class="'btn btn-success btn-fill w-100 mb-4 ml-auto'"
                @click.prevent="gerarExcell"
              >Baixar Relatório</button>
            </div>
          </div>
        </div>

        <div class="col-12 d-print-none ">
          <card class="strpied-tabled-with-hover" body-classes="table-responsive">
            <template slot="header">
              <h2 class="card-title">Estatísticas</h2>
              <p class="card-category"></p>
            </template>

            <div class="row mb-4">
              <div class="col-md-6">
                <h3>Quantidade de Embarques</h3>
                <hr />
                <quant-embarques :estatisticaInfo="estatisticaInfo"></quant-embarques>
              </div>
              <div class="col-md-6">
                <h3>Quilos Embarcados</h3>
                <hr />
                <kilos-embarcados :estatisticaInfo="estatisticaInfo"></kilos-embarcados>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-md-6">
                <h3>Modais por Embarque</h3>
                <hr />
                <modalidades-embarques :estatisticaInfo="estatisticaInfo"></modalidades-embarques>
              </div>
              <div class="col-md-6">
                <h3>TEUS Embarques</h3>
                <hr />
                <quant-teus-embarques :estatisticaInfo="estatisticaInfo"></quant-teus-embarques>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-md-6">
                <h3>Principais Origens Importação</h3>
                <hr />
                <principais-origens-impo :estatisticaInfo="estatisticaInfo"></principais-origens-impo>
              </div>
              <div class="col-md-6">
                <h3>Principais Destinos Exportação</h3>
                <hr />
                <principais-destinos-expo :estatisticaInfo="estatisticaInfo"></principais-destinos-expo>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-md-12">
                <h3>Principais Fornecedores - Importação</h3>
                <hr />
                <principais-fornecedores-impo :estatisticaInfo="estatisticaInfo"></principais-fornecedores-impo>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-12">
                <h3>Principais Clientes Exportação</h3>
                <hr />
                <principais-clientes-expo :estatisticaInfo="estatisticaInfo"></principais-clientes-expo>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-12">
                <h3>Histórico de Embarques</h3>
                <hr />
                <embarques-historicos :estatisticaInfo="estatisticaInfo"></embarques-historicos>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-12">
                <h3>Histórico de Quilos Embarcados</h3>
                <hr />
                <kilos-historicos :estatisticaInfo="estatisticaInfo"></kilos-historicos>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-12">
                <h3>Histórico de TEUS Embarcados</h3>
                <hr />
                <teus-historicos :estatisticaInfo="estatisticaInfo"></teus-historicos>
              </div>
            </div>

            <div class="row mb-4 d-none">
              <div class="col-12">
                <table id="data-table" border="1">
                  <thead>
                    <tr>
                      <th colspan="3">
                        <b>{{ this.empresaInfo.nomeEmpresa }}</b>
                      </th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Tracking</th>
                    </tr>
                    <tr>
                      <td colspan="3"></td>
                      <td style="font-size:14px !important; font-family: Arial !important;">Data Inicial:</td>
                      <td style="font-size:14px !important; font-family: Arial !important;">{{ estatisticaInfo.dataInicial | moment("DD-MM-YYYY") }}</td>
                    </tr>
                    <tr>
                      <td colspan="3"></td>
                      <td style="font-size:14px !important; font-family: Arial !important;">Data Final:</td>
                      <td style="font-size:14px !important; font-family: Arial !important;">{{ estatisticaInfo.dataFinal | moment("DD-MM-YYYY") }}</td>
                    </tr>
                    <tr>
                      <td colspan="3"></td>
                      <td style="font-size:14px !important; font-family: Arial !important;">Usuario:</td>
                      <td style="font-size:14px !important; font-family: Arial !important;">{{estatisticaInfo.username  }}</td>
                    </tr>
                    <tr>
                      <td colspan="3"></td>
                      <td style="font-size:14px !important; font-family: Arial !important;">Data:</td>
                      <td style="font-size:14px !important; font-family: Arial !important;">{{ new Date() | moment("DD-MM-YYYY") }}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th style="font-size:14px !important; font-family: Arial !important;">Processo</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Cliente</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Shipper</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Cnee</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Agente</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Origem</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Destino</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Destino Final</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Embarque Criado</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">ETD</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">ETA</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">ETA Destino Final</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Master</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">House</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Booking</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Carrier</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Navio</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Ref Cliente</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Mecadoria</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Volumes</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">M3</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Peso Cobrar</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Peso Bruto</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Destino</th>
                      <th style="font-size:14px !important; font-family: Arial !important;">Incoterm</th>
                    </tr>
                    <tr v-for="item in relatorio">
                      <td v-for="value in item">{{value}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </card>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraficoBarra from "src/components/graficos/GraficoBarra.vue";
import QuantEmbarques from "src/components/Charts/QuantEmbarques.vue";
import KilosEmbarcados from "src/components/Charts/KilosEmbarcados.vue";
import QuantTeusEmbarques from "src/components/Charts/QuantTeusEmbarques.vue";
import ModalidadesEmbarques from "src/components/Charts/ModalidadesEmbarques.vue";
import PrincipaisOrigensImpo from "src/components/Charts/PrincipaisOrigensImpo.vue";
import PrincipaisDestinosExpo from "src/components/Charts/PrincipaisDestinosExpo.vue";
import PrincipaisFornecedoresImpo from "src/components/Charts/PrincipaisFornecedoresImpo.vue";
import PrincipaisClientesExpo from "src/components/Charts/PrincipaisClientesExpo.vue";
import EmbarquesHistoricos from "src/components/Charts/EmbarquesHistoricos.vue";
import KilosHistoricos from "src/components/Charts/KilosHistoricos.vue";
import TeusHistoricos from "src/components/Charts/TeusHistoricos.vue";
import FilterEstatisticas from "src/components/Filters/FilterEstatisticas.vue";

export default {
  components: {
    GraficoBarra,
    QuantEmbarques,
    KilosEmbarcados,
    QuantTeusEmbarques,
    ModalidadesEmbarques,
    PrincipaisOrigensImpo,
    PrincipaisDestinosExpo,
    PrincipaisFornecedoresImpo,
    PrincipaisClientesExpo,
    EmbarquesHistoricos,
    KilosHistoricos,
    TeusHistoricos,
    FilterEstatisticas
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      chartChange: false,
      loadingRelatorio: true,
      title: "Webtracking",
      empresaInfo: {
        logoEmpresa: "",
        nomeEmpresa: "",
      },
      estatisticaInfo: {
        userID: "",
        username: "",
        dataInicial: this.$moment(new Date()).subtract(30, 'days').format("YYYY-MM-DD"),
        dataFinal: this.$moment(new Date()).format("YYYY-MM-DD"),
        listClients: "",
        nomeCliente: "",
        breakPoint: ""
      },
      relatorio: ""
    };
  },
  mounted() {
    let loginInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
    this.estatisticaInfo.userID = loginInfo.userID;
    this.estatisticaInfo.username = loginInfo.username;
    this.estatisticaInfo.listClients = loginInfo.listClients;
    this.checkEmpresaInfo();
    this.gerarRelatorio();
  },
  methods: {
    updateFiltrosEstatisticas(data) {
      this.estatisticaInfo.dataInicial = data.dataInicial;
      this.estatisticaInfo.dataFinal = data.dataFinal;
      this.estatisticaInfo.nomeCliente = data.nomeCliente;
      this.estatisticaInfo.breakPoint = data.breakPoint;
      this.chartChange = !this.chartChange;
      this.gerarRelatorio();
    },
    gerarRelatorio() {
      this.loadingRelatorio = true;
      var url = this.$urlApi + "/api/estatisticas-gerar-relatorios";
      this.axios.post(url, this.estatisticaInfo).then(res => {
        this.relatorio = res.data.response;
        this.loadingRelatorio = false;
      });
    },
    gerarExcell() {
      // var wb = this.$xlsx.utils.table_to_book(
      //   document.getElementById("data-table"),
      //   { sheet: "Sheet JS" }
      // );
      // var wbout = this.$xlsx.write(wb, {
      //   bookType: "xlsx",
      //   bookSST: true,
      //   type: "binary"
      // });
      // function s2ab(s) {
      //   var buf = new ArrayBuffer(s.length);
      //   var view = new Uint8Array(buf);
      //   for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      //   return buf;
      // }
      // this.$saveAs(
      //   new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      //   "relatorio.xlsx"
      // );
      
      var tableToExcel = (function() {
            var uri = 'data:application/vnd.ms-excel;base64,'
                , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
            return function(table, name) {
                    table = document.getElementById("data-table")
                var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
                window.location.href = uri + base64(format(template, ctx))
            }
        })()
        tableToExcel();
    },
    checkLoadingRelatorio(){
      if(this.loadingRelatorio && this.loadingRelatorio == false){
        return "";
      }else{
        return "disabled";
      }
    },
    checkEmpresaInfo() {
      let info = JSON.parse(sessionStorage.getItem("empresaInfo"));
      console.log(info);
      if (info) {
        if (info.hasOwnProperty("LINK")) {
          if (info.LINK != "" && info.LINK != null)
            this.empresaInfo.logoEmpresa = info.LINK;
        }
        if (info.hasOwnProperty("NOME")) {
          if (info.NOME != "" && info.NOME != null)
            this.empresaInfo.nomeEmpresa = info.NOME;
        }
      }
    }
  },

};
</script>

<style>
</style>